class StickyBar {
    constructor({ el, offset, checkUpScroll = true }) {
        this.el = el;
        this.initialOffset = offset;
        this.checkUpScroll = checkUpScroll
        this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        this.stickyHeader = document.querySelector('.js-sticky-header');
        this.scrollSection = this.el.querySelector('.sticky-bar__nav');

        this.errorMargin = 4;

        this.isMouseDown = false;
        this.startX = null;
        this.scrollLeft = null;

        this.offset = this.getOffset(this.initialOffset);

        document.addEventListener('scroll', this.checkPosition.bind(this));
        document.addEventListener('resize', this.setOffset.bind(this));

        this.scrollSection.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.scrollSection.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        this.scrollSection.addEventListener('mouseup', this.onMouseUp.bind(this));
        this.scrollSection.addEventListener('mousemove', this.onMouseMove.bind(this));

        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio < 1 ) {
                this.el.classList.add('is-sticky');
            } else if (!this.el.classList.contains('scroll-up')) {
                this.el.classList.remove('is-sticky');
            }
        }, {
            rootMargin: '-1px 0px 0px 0px',
            threshold: [1]
        });

        this.observer.observe(this.el);

        this.checkPosition();
    }

    checkPosition() {
        const iScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        // Scrolling up
        if (this.checkUpScroll) {
            if (iScrollPosition < this.currentScrollPosition) {
                this.el.classList.add('scroll-up');
            } else {
                this.el.classList.remove('scroll-up');
            }
        }

        if (this.el.getBoundingClientRect().top > this.el.getBoundingClientRect().height) {
            this.el.classList.remove('is-sticky');
        }

        this.currentScrollPosition = iScrollPosition;
    }

    setOffset() {
        this.offset = this.getOffset(this.initialOffset);
    }

    getOffset(offset) {
        if (typeof offset === 'number') {
            return offset + this.el.getBoundingClientRect().top;
        }

        return (this.el.getBoundingClientRect().top + window.pageYOffset);
    }

    onMouseDown(e) {
        this.isDown = true;
        this.scrollSection.classList.add('is-active');
        this.startX = e.pageX - this.scrollSection.offsetLeft;
        this.scrollLeft = this.scrollSection.scrollLeft;
    }

    onMouseLeave(e) {
        this.isDown = false;
        this.scrollSection.classList.remove('is-active');
    }

    onMouseUp(e) {
        this.isDown = false;
        this.scrollSection.classList.remove('is-active');
    }

    onMouseMove(e) {
        if(!this.isDown) return;

        e.preventDefault();

        const x = e.pageX - this.scrollSection.offsetLeft;
        const walk = (x - this.startX) * 1.2;
        this.scrollSection.scrollLeft = this.scrollLeft - walk;
    }
}